module.exports = __webpack_public_path__ + "img/qr_member_screenshot.9f955910.png";